<template>
  <v-container v-resize="onResize">
    <v-layout row wrap align-center>
      <v-flex xs12>
        <h1>Committees</h1>
      </v-flex>
    </v-layout>
    <template>
      <v-card v-if="loading || !this.$store.state.OBJ_APPLICATION_INIT_LOADED">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="loader"></div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </template>
    <div v-show="!loading && this.$store.state.OBJ_APPLICATION_INIT_LOADED">
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-layout row wrap align-center>
            <v-flex xs12 md12 xl12>
              <v-layout row wrap>
                <v-flex sm4>
                  <count-up
                    :endVal="currentCommitteeCount"
                    text="Committees in this Parliament"
                  />
                </v-flex>
                <v-flex sm4>
                  <count-up
                    :endVal="committeeCount"
                    text="Committees in total"
                  />
                </v-flex>
                <v-flex sm4>
                  <count-up
                    :endVal="parliamentariansOnCommittees"
                    :countOptions="totalStatsOptions"
                    text="of Parliamentarians have <br/>served on committees"
                  />
                </v-flex>
              
              </v-layout>

              <v-layout row wrap align-center>
                <v-flex xs12 sm6 md4 xl4>
                  <v-card-title class="pb-0 mb-0">
               
                    <v-text-field
                      :class="{mobileTextField: isMobile}" 
                      v-on:keyup="TRACK_SEARCH"
                      v-model="committeeSearch"
                      append-icon="search"
                      label="Search Committees"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                             <v-subheader
                                >
                                Sort by:
                                </v-subheader>
                            <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                  </v-card-title>
                </v-flex>
                <v-flex xs12 sm6 md4 xl4>
                  <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                      label="Filter by committee types"
                      v-model="COMMITTEE_TYPES_SELECTED"
                      :items="COMMITTEE_TYPE_OPTIONS"
                      item-text="Filter"
                      item-value="Filter"
                      :search-input.sync="committeeSearchInput"
                      auto-select-first
                       clearable
                      multiple
                      small-chips
                      deletable-chips
                      v-on:change="FILTERBY_TYPE"
                    >
                    <template v-slot:selection="{ item, index }">
                        <v-chip @input="deleteCommitteeSelectionItem(item)" small close v-if="index == 0">{{item}}</v-chip>
                        <v-chip small v-if="index == 1">+ {{COMMITTEE_TYPES_SELECTED.length - 1}} more</v-chip>
                    </template>
                    </v-autocomplete>
                  </v-card-title>
                </v-flex>
                <v-flex xs12 sm6 md4 xl4>
                  <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                      label="Select a Parliament"
                      v-model="SELECTED_PARLIAMENTS"
                      :items="this.$store.getters.GET_PARLIAMENTS_ORDERED"
                      item-text="Name"
                      item-value="PID"
                      v-on:change="FILTERBY_PARLIAMENT"
                      :filter="FILTER_PARLIAMENT_OPTIONS"
                      auto-select-first
                      multiple
                      small-chips
                       clearable
                      deletable-chips>
                      <template v-slot:selection="{ item, index }">
                            <v-chip @input="deleteParliamentSelectionItem(item.Name)" small close v-if="index == 0">{{item.Name}}</v-chip>
                            <v-chip small v-if="index == 1">+ {{SELECTED_PARLIAMENTS.length - 1}} more</v-chip>
                        </template>
                      <template
                        v-slot:prepend-item
                        v-if="this.$store.getters.GET_PARLIAMENTS.length > 0">
                        <v-list-tile
                          v-on:click="CLICK_CURRENTPARLIAMENT"
                          :value="currentParliamentValue"
                          ripple>
                          <v-list-tile-action>
                            <v-icon>{{ currentParliamentIcon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title
                              >Current Parliament</v-list-tile-title
                            >
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-card-title>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <br />

    <div
      v-if="
        !loading &&
        viewType === 'table' &&
        this.$store.state.OBJ_APPLICATION_INIT_LOADED
      "
      style="margin-top: -10px"
      class="stats-table"
    >
      <v-data-table
        :headers="HEADERS"
        :items="DATATABLE_COMMITTEES"
        :rows-per-page-items="ROWS_LISTITEMS"
        :search="committeeSearch"
        :pagination.sync="PAGINATION"
        :hide-headers="isMobile"
        :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
        v-on:update:pagination="UPDATE_PAGINATION"
      >
        <template v-slot:items="props">
            <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_COMMITTEE, params: { CID: props.item.CID, parliaments: SELECTED_PARLIAMENTS }}">
                 <td>
                    <div class="flex-content">
                        <div class="flex-item pt-2">
                            <h3 class="pb-xs-0">{{ props.item.CommitteeName }}</h3>
                        </div>
                        <div class="flex-item">
                            <v-chip class="ma-0"
                                small label :color="props.item.CommitteeChamber == 'Senate'
                                    ? $store.state.COLOUR_SENATE
                                    : props.item.CommitteeChamber == 'House'
                                    ? $store.state.COLOUR_REPRESENTATIVES
                                    : $store.state.COLOUR_JOINT">
                                {{ props.item.CommitteeType }}
                            </v-chip>
                        </div>
                        <div class="flex-item flex-item-col" data-label="Service start">
                            {{ props.item.ServiceStartDate | stringDateFormat }}
                        </div>
                        <div class="flex-item flex-item-col" data-label="Service end">
                            {{ props.item.Current ? "Current" : "" }}
                            {{ props.item.ServiceEndDate | stringDateFormat }}
                        </div>
                        <div class="flex-item flex-item-col" v-if="props.item.CurrentMemberCount !== 0" data-label="Current members">
                            {{ props.item.CurrentMemberCount === 0 ? "" : props.item.CurrentMemberCount }}
                        </div>
                        <div class="flex-item flex-item-col" data-label="Total members">
                            {{ props.item.MemberCount === 0 ? "" : props.item.MemberCount }}
                        </div>
                    </div>
                </td>
            </router-link>
            <router-link v-else class="tr" :to="{ name: $store.state.ROUTE_COMMITTEE, params: { CID: props.item.CID, parliaments: SELECTED_PARLIAMENTS }}">
                <td class="text-xs-left">
                    <v-chip :class="props.item.CommitteeType.indexOf('General Purpose') > -1 ? 'generalPurposeStanding' : ''"
                        small label :color="props.item.CommitteeChamber == 'Senate'
                            ? $store.state.COLOUR_SENATE
                            : props.item.CommitteeChamber == 'House'
                            ? $store.state.COLOUR_REPRESENTATIVES
                            : $store.state.COLOUR_JOINT">
                        {{ props.item.CommitteeType }}
                    </v-chip>
                </td>
                <td class="text-xs-left">{{ props.item.CommitteeName }}</td>
                <td class="text-xs-left">
                    {{ props.item.ServiceStartDate | stringDateFormat }}
                </td>
                <td class="text-xs-left">
                    {{ props.item.Current ? "Current" : "" }}
                    {{ props.item.ServiceEndDate | stringDateFormat }}
                </td>
                <td class="text-xs-center">
                    {{ props.item.CurrentMemberCount === 0 ? "" : props.item.CurrentMemberCount }}
                </td>
                <td class="text-xs-center">
                    {{ props.item.MemberCount === 0 ? "" : props.item.MemberCount }}
                </td>
            </router-link>
        </template>

        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ committeeSearch }}" found no results.
          </v-alert>
        </template>
      </v-data-table>

      <br/>
        <v-layout row wrap>
            <v-flex xs12>
                <v-btn class="csvButton" v-if="DATATABLE_COMMITTEES.length"  @click="EXPORT_COMMITTEE_CSV" v-on:keyup.enter="EXPORT_COMMITTEE_CSV" color="primary">
                    <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                    <span>&nbsp;Download as CSV</span>
                </v-btn>
            </v-flex>
        </v-layout>
    </div>
    <br />
  </v-container>
</template>

<script>
window.scrollTo(0, 0);
import axios from "axios";
import moment from "moment";
window.Handbook = window.Handbook || {};
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import CountUp from "../StatisticalInformation/CountUp.vue";
import Chart from "../StatisticalInformation/Chart.vue";

export default {
  data() {
    return {
    isMobile: false,
      viewType: "table",
      loading: true,
      totalStatsOptions: {
        suffix: "%",
      },
      currentParliament: 0,
      committees: [],
      committeeCount: 0,
      currentCommitteeCount: 0,
      chartItems: [],
      chartParties: [],
       csvDownloading: false,
      DATATABLE_COMMITTEES: [],
      committeeData: [],
      committeeSearch: "",
      committeeSearchInput: "",
      CSV_HEADERS: [
        "CID",
        "CommitteeName",
        "CommitteeType",
        "CommitteeChamber",
      ],
      CSV_FILENAME: "Handbook-Committees",
      ROWS_LISTITEMS: [
        10,
        20,
        50,
        100,
        {
          text: "$vuetify.dataIterator.rowsPerPageAll",
          value: -1,
        },
      ],
      PAGINATION: {
        rowsPerPage: 50,
        sortBy: "CommitteeName",
      },
      HEADERS: [
        {
          text: "Committee type",
          value: "CommitteeType",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Committee name",
          value: "CommitteeName",
          align: "left",
          sortable: true,
          model: this.committeeName,
        },
        {
          text: "Member service start",
          value: "StartDate",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Member service end",
          value: "EndDate",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Current members",
          value: "CurrentMemberCount",
          align: "left",
          sortable: true,
          width: "100px",
        },
        {
          text: "Total members",
          value: "MemberCount",
          align: "left",
          sortable: true,
          width: "100px",
        },
      ],
      parliamentariansOnCommittees: 0,
      stats: [],
      totalStats: [],
      PARLIAMENTS: this.$store.getters.GET_PARLIAMENTS,
      SELECTED_PARLIAMENTS: [],
      COMMITTEE_TYPE_OPTIONS: [
        "All types",
        "House of Representatives Select",
        "House of Representatives Standing",
        "Senate Estimates",
        "Senate Legislative and General Purpose Standing",
        "Senate Select",
        "Senate Standing",
        "Joint Select",
        "Joint Standing",
        "Joint Statutory",
      ],
      COMMITTEE_TYPES_SELECTED: [],
      COMMITTEE_TYPES_SELECTED_PREVIOUS: [],
    };
  },
  created() {
    this.loadCommittees();
  },
  methods: {
      onResize() {
        if (window.innerWidth < 769){
            this.isMobile = true;
        }
        else{
            this.isMobile = false;
        }
    },
    changeSort(column) {
        if (this.PAGINATION.sortBy === column) {
            this.PAGINATION.descending = !this.PAGINATION.descending
        } 
        else {
            this.PAGINATION.sortBy = column
            this.PAGINATION.descending = false
        }
    },
    deleteCommitteeSelectionItem(item) {
        this.COMMITTEE_TYPES_SELECTED = this.COMMITTEE_TYPES_SELECTED.filter(find => find !== item);
        this.FILTERBY_TYPE(this.COMMITTEE_TYPES_SELECTED);
    },
    deleteParliamentSelectionItem(item) {
        this.SELECTED_PARLIAMENTS = this.SELECTED_PARLIAMENTS.filter(find => find.Name !== item.Name);
        this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
    },
    loadCommittees() {
      this.loading = true;
      const url ="committees?Select=CID,CommitteeChamber,CommitteeType,CommitteeName";
        axios.get(`api/${url}`).then((response) => {
        this.committeeData = response.data.value;
        this.DATATABLE_COMMITTEES = this.committeeData;
      });

      const statsUrl = `StatisticalInformation/CommitteeStatistics?mpOrSenator=&fullData=true`;
      axios.get(`api/${statsUrl}`).then((response) => {
        this.stats = response.data;
        this.totalStats = response.data.StatisticsByParliament.find(
          (p) => p.ParliamentNumber == "0"
        );
        this.currentParliament = Math.max(
          ...response.data.StatisticsByParliament.map((s) =>
            parseInt(s.ParliamentNumber)
          )
        );
        this.currentCommitteeCount = response.data.StatisticsByParliament.find((p) => p.ParliamentNumber == this.currentParliament).CommitteeCount;
        this.committeeCount = response.data.Committees.length;
        this.parliamentariansOnCommittees = (this.totalStats.ParliamentarianOnCommitteesCount / this.totalStats.ParliamentarianCount) * 100;
        // this.committees = response.data.Committees.slice().reverse();

        this.FILTER_COMMITTEES();
        this.loading = false;
      });
    },
    FILTER_COMMITTEES: function () {
      // create a function scoped var to hold all Committees
      let OBJ_records = this.committeeData;
      let OBJ_types = [];
      let index = 0;

      var currentObjRecords = [];
      if (this.SELECTED_PARLIAMENTS.length == 0){
          OBJ_records = this.committeeData;
      }

      for (index = 0; index < this.SELECTED_PARLIAMENTS.length; ++index) {
        var internalRecords = this.committeeData;

        //  FILTERS_SELECTED_PARLIAMENTS
        var parliament = this.$store.getters.GET_PARLIAMENT_BYPID(
          parseInt(this.SELECTED_PARLIAMENTS[index])
        );
        if (!parliament) {
          continue;
        }

        var existingIDs = currentObjRecords.map((obj) => obj.CID);

        var filtered = internalRecords
          .filter((Obj) => Obj.ParliamentList.indexOf(parliament.PID) > -1 && existingIDs.indexOf(Obj.CID) == -1)
          .map((record) => ({ ...record, Parliament: parliament.PID }));

        currentObjRecords = currentObjRecords.concat(filtered);
      }

      OBJ_records = currentObjRecords;

      if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
        if (OBJ_records.length === 0) {
          OBJ_records = this.committeeData;
        }

        var showAll = false;

        for (index = 0; index < this.COMMITTEE_TYPES_SELECTED.length; ++index) {
          var txtVal = this.COMMITTEE_TYPES_SELECTED[index].replace(
            " of Representatives",
            ""
          );
          if (txtVal == "All types") {
            showAll = true;
          }
          OBJ_types = OBJ_types.concat(
            OBJ_records.filter((Obj) => Obj.CommitteeType === txtVal)
          );
        }

        if (showAll) {
          OBJ_types = OBJ_records;
        }
      }

      const recordsResult = OBJ_types;

      let query = this.$router.query || {};

      if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
        query.committeeTypes = this.COMMITTEE_TYPES_SELECTED.join(",");
      }

      if (this.SELECTED_PARLIAMENTS.length > 0) {
        query.parliaments = this.SELECTED_PARLIAMENTS.join(",");
      }

      if (this.committeeSearch) {
        query.s = this.committeeSearch;
      }

      if (this.COMMITTEE_TYPES_SELECTED.length > 0) {
        this.DATATABLE_COMMITTEES = this._.sortBy(
          recordsResult,
          "CommitteeName"
        );
      } else {
        this.DATATABLE_COMMITTEES = [];
      }

      if (this.PAGINATION.page > 1) {
        query.page = this.PAGINATION.page;
      }

      if (this.PAGINATION.pageSize != 50) {
        query.pageSize = this.PAGINATION.rowsPerPage;
      }

      if (Object.keys(query).length > 0) {
        history.replaceState(
          {},
          null,
          this.$route.path +
            "?" +
            Object.keys(query)
              .map((key) => {
                return key + "=" + query[key];
              })
              .join("&")
        );
      } else {
        history.replaceState({}, null, this.$route.path);
      }

      return true;
    },
    FILTERBY_TYPE: function (types) {
      //No types, add all
      if (types.length == 0) {
        this.COMMITTEE_TYPES_SELECTED.push("All types");
      } else {
        //Went from no items (on load) to multiple. Remove 'All types'
        if (
          this.COMMITTEE_TYPES_SELECTED_PREVIOUS.length == 0 &&
          this.COMMITTEE_TYPES_SELECTED.length > 1 &&
          this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1
        ) {
          this.COMMITTEE_TYPES_SELECTED.splice(
            this.COMMITTEE_TYPES_SELECTED.indexOf("All types"),
            1
          );
        }
        //Previous list didn't have all types, now we are adding it, allow this to happen
        else if (
          this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1 &&
          (this.COMMITTEE_TYPES_SELECTED_PREVIOUS.indexOf("All types") == -1 ||
            this.COMMITTEE_TYPES_SELECTED_PREVIOUS.length == 0)
        ) {
          this.COMMITTEE_TYPES_SELECTED = ["All types"];
        }
        //In all other cases, remove 'all types' if user has selected other options
        else if (this.COMMITTEE_TYPES_SELECTED.indexOf("All types") > -1) {
          this.COMMITTEE_TYPES_SELECTED.splice(
            this.COMMITTEE_TYPES_SELECTED.indexOf("All types"),
            1
          );
        }
      }

      this.$gtag.event("committees by name type filter", {
        event_category: "filters",
        event_label: `types selected: ${
          types.length > 0 ? types.join(",") : "none"
        }`,
        value: 1,
      });
      this.committeeSearchInput = "";
      this.COMMITTEE_TYPES_SELECTED_PREVIOUS = types;
      return this.FILTER_COMMITTEES();
    },
    FILTERBY_PARLIAMENT: function (parliaments) {
      this.$gtag.event("committees by parliament parliament filter", {
        event_category: "filters",
        event_label: `parliaments selected: ${
          parliaments.length > 0 ? parliaments.join(",") : "none"
        }`,
        value: 1,
      });
      return this.FILTER_COMMITTEES();
    },
    FILTER_PARLIAMENT_OPTIONS: function (item, queryText) {
      const pId = item.PID;
      const name = item.Name.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        name.indexOf(searchText) > -1 || pId.toString().indexOf(searchText) > -1
      );
    },
    CLICK_CURRENTPARLIAMENT: function () {
      this.$nextTick(() => {
        let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                    let currentParliament = parliaments[0].PID;
                    if (this.SELECTED_PARLIAMENTS.includes(currentParliament)) {
                        let index = this.SELECTED_PARLIAMENTS.indexOf(currentParliament);
                        if (index > -1) {
                            this.SELECTED_PARLIAMENTS.splice(index, 1);
                        }
                    } else {
                        this.SELECTED_PARLIAMENTS.push(currentParliament);
                    }
        this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
      });
    },
    TRACK_SEARCH: function (search) {
      this.$gtag.event("filter committees by name - search", {
        event_category: "filters",
        event_label: search,
        value: 1,
      });
      return this.FILTER_COMMITTEES();
    },
    UPDATE_PAGINATION: function (options) {
      this.$gtag.event("committees by name pagination items per page", {
        event_category: "filters",
        event_label: `items per page: ${options.rowsPerPage}`,
        value: 1,
      });
      this.$gtag.event("committees by name pagination page", {
        event_category: "filters",
        event_label: `page: ${options.page}`,
        value: 1,
      });
      this.$gtag.event(`committees by name sorting`, {
        event_category: "sorting",
        event_label: `sort by ${options.sortBy} ${
          options.descending ? "DESC" : "ASC"
        }`,
        value: 1,
      });

        this.FILTER_COMMITTEES();
      return this.PAGINATION;
    },
    EXPORT_COMMITTEE_CSV: function () {
      this.csvDownloading = true;
      let headers = [
        "CID",
        "CommitteeName",
        "CommitteeType",
        "CommitteeChamber",
      ];
      let filename = `Handbook_Committees`;
      let index = 0;
      let OBJ_records = [];
      for (index = 0; index < this.DATATABLE_COMMITTEES.length; ++index) {
        OBJ_records.push({
          "Committee ID": this.DATATABLE_COMMITTEES[index].CID,
          "Committee Chamber":
            this.DATATABLE_COMMITTEES[index].CommitteeChamber,
          "Committee Type": this.DATATABLE_COMMITTEES[
            index
          ].CommitteeType.replace(
            this.DATATABLE_COMMITTEES[index].CommitteeChamber,
            ""
          ),
          "Committee Name": this.DATATABLE_COMMITTEES[index].CommitteeName,
          Status:
            this.DATATABLE_COMMITTEES[index].Current == true
              ? "Current"
              : "Former",
          "Committee Start":
            this.DATATABLE_COMMITTEES[index].StartDate !=
              "1900-01-01T00:00:00Z" &&
            this.DATATABLE_COMMITTEES[index].StartDate != "1900-01-1" &&
            this.DATATABLE_COMMITTEES[index].StartDate != "0001-01-01" &&
            this.DATATABLE_COMMITTEES[index].StartDate != "0001-01-01T00:00:00Z"
              ? this.formatDate(
                  this.DATATABLE_COMMITTEES[index].StartDate,
                  "",
                  "YYYY-MM-DD",
                  false
                )
              : "",
          "Committee End":
            this.DATATABLE_COMMITTEES[index].EndDate !=
              "1900-01-01T00:00:00Z" &&
            this.DATATABLE_COMMITTEES[index].EndDate != "1900-01-1" &&
            this.DATATABLE_COMMITTEES[index].EndDate != "0001-01-01" &&
            this.DATATABLE_COMMITTEES[index].EndDate != "0001-01-01T00:00:00Z"
              ? this.formatDate(
                  this.DATATABLE_COMMITTEES[index].EndDate,
                  "",
                  "YYYY-MM-DD",
                  false
                )
              : "",
          "Current Members":
            this.DATATABLE_COMMITTEES[index].CurrentMemberCount,
          "Total Members": this.DATATABLE_COMMITTEES[index].MemberCount,
        });
      }
      this.$store
        .dispatch("GETCSV", {
          DATA: OBJ_records,
          HEADERS: headers,
          FILENAME: filename,
        })
        .catch(this.showError)
        .finally(() => (this.csvDownloading = false));

      OBJ_records = null;
      index = null;
    },
    getColor(chamber) {
      if (chamber == "House") {
        return this.$store.state.COLOUR_REPRESENTATIVES;
      } else if (chamber == "Senate") {
        return this.$store.state.COLOUR_SENATE_BRIGHT;
      } else if (chamber == "Joint") {
        return this.$store.state.COLOUR_JOINT;
      }
    },
  },
  mounted() {
    this.onResize();
    //Set page to 10 on mobile, only on mount
    if (this.isMobile){
        this.PAGINATION.rowsPerPage = 10;
    }

    if (this.$route.query.s) {
      this.committeeSearch = this.$route.query.s;
    }

    if (this.$route.query.committeeTypes) {
      this.COMMITTEE_TYPES_SELECTED = this.$route.query.committeeTypes
        .split(",")
        .map((p) => p.replace("%20", ""));
    } else {
      this.COMMITTEE_TYPES_SELECTED = ["All types"];
    }

    if (this.$route.query.parliaments) {
      this.SELECTED_PARLIAMENTS = this.$route.query.parliaments
        .split(",")
        .map((p) => parseInt(p));
    }

    if (this.SELECTED_PARLIAMENTS.length === 0) {
        let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;

        if (parliaments.length > 0){
            let currentParliament = parliaments[0].PID;

            this.ParlStartDate = this.$store.getters.GET_PARLIAMENT_BYPID(parseInt(currentParliament)).DateOpening == "" ? 
                this.$store.getters.GET_PARLIAMENT_BYPID(parseInt(currentParliament)).DateElection
                :this.$store.getters.GET_PARLIAMENT_BYPID(parseInt(currentParliament)).DateOpening;

            var nowDate = new Date(); 
            var currentDate = nowDate.getFullYear()+'-'+(nowDate.getMonth()+1)+'-'+nowDate.getDate(); 

            var currentParlStartDate = new Date(Date.parse(this.ParlStartDate))

            if (Date.parse(currentParlStartDate.getFullYear()+'-'+(currentParlStartDate.getMonth()+1)+'-'+currentParlStartDate.getDate()) <= Date.parse(currentDate)) {
                this.SELECTED_PARLIAMENTS.push(currentParliament);
            }
        }
    }

    if (this.$route.query.page) {
        this.PAGINATION.page = parseInt(this.$route.query.page);
    }

    if (this.$route.query.pageSize) {
        this.PAGINATION.rowsPerPage = parseInt(this.$route.query.pageSize);
    }

    this.FILTER_COMMITTEES();
  },
  computed: {
    csvDownloadIcon(){
        return this.csvDownloading ? 'cached' : 'text_snippet';
    },
    csvDownloadClass(){
        let csvClass = 'mr-1';
        if (this.csvDownloading){
            csvClass = csvClass + ' loading'
        }
        return csvClass;
    },
    currentParliamentIcon: function () {
      let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
        let currentParliament = parlArray[0].PID;
        if (this.SELECTED_PARLIAMENTS.indexOf(currentParliament) > -1) {
            return '$vuetify.icons.checkboxOn';
        } else {
            return '$vuetify.icons.checkboxOff';
        }
    },
    currentParliamentValue: function () {
      let parlArray = this.$store.getters.GET_PARLIAMENTS;
      if (
        this.SELECTED_PARLIAMENTS.includes(parlArray[parlArray.length - 1].PID)
      ) {
        return parlArray[parlArray.length - 1].PID;
      } else {
        return false;
      }
    },
  },
  beforeDestroy() {
    // this.unwatch();
  },
  components: {
    Chart,
    CountUp,
  },
};
</script>

<style lang="stylus" scoped>

.v-datatable .tr {
    display:table-row;
}

.v-datatable a.tr {
    color: #0e1531de;
    text-decoration:none;
    border: 1px solid #dbdbdb;
    border-left: none;
    border-right: none;
}

.v-datatable tbody td {
    vertical-align: middle;
}

.v-progress-circular {
  margin: 1rem;
}

a {
  color: #fff;
  text-decoration: underline;
}

a.menu_links {
  cursor: pointer;
}

.v-progress-circular {
  margin: 1rem;
}

a {
  color: #fff;
  text-decoration: underline;
}

a.menu_links {
  cursor: pointer;
}

.AZ-dividers {
  width: 3.7%;
  cursor: pointer;
}

.handbook_Button {
  width: 100% !important;
  padding: 0px 2px 2px 2px;
  color: #F5F5F5 !important;
}

.chamberButtonText {
  color: #F5F5F5;
}

.generalPurposeStanding {
  height: 35px !important;
  line-height: 14px;
}

.generalPurposeStanding >>> .v-chip__content {
  width: 180px !important;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

table.v-table tbody td:first-child {
  padding: 0 14px;
}

.v-text-field__details {
  display: none;
}

.committeesTimeline >>> .highcharts-container {
  width: 100% !important;
}

.committeesTimeline >>> .highcharts-container .highcharts-root {
  width: 100% !important;
}

.committeesTimeline >>> .highcharts-container .highcharts-root > .highcharts-background {
  width: 100% !important;
}



.v-messages {
  display: none;
}

@media screen and (max-width: 1420px) {
        .stats-table >>> table.v-table thead td:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead th:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead td:first-child, 
        .stats-table >>> table.v-table tbody td:first-child, 
        .stats-table >>> table.v-table thead th:first-child, 
        .stats-table >>> table.v-table tbody th:first-child,
        .stats-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .stats-table >>> th {
            white-space: break-spaces;
        }
    }
</style>
<style scoped>
.v-messages {
  display: none !important;
}


</style>